export default "__VITE_ASSET__BACeCa_w__"